// "In-course coach" (not to be confused with AI "Coursera Coach") messages
export const CREATE_GOAL_MESSAGE_TYPE = 'createGoalMessage';
export const GOAL_PROGRESS_MESSAGE_TYPE = 'goalProgressMessage';
export const WEEK_COMPLETION_MESSAGE = 'weekCompletionMessage';
export const COURSE_COMPLETED_MESSAGE_TYPE = 'courseCompletionMessage';
export const ITEM_COMPLETION_AHEAD_OF_SCHEDULE_MESSAGE_TYPE = 'itemCompletionBeforeDeadlineMessage';
export const MODULE_COMPLETION_MESSAGE_TYPE = 'moduleCompletionMessage';
export const COURSE_COMPLETION_MESSAGE_TYPE = 'courseCompletionCelebrationMessage';
export const WEEKLY_STREAK_PROGRESS_COMPLETION_MESSAGE_TYPE = 'weeklyStreakProgressCompletionMessage';

// Experimental messages
export const LEARNER_MT_SURVEY_MESSAGE_TYPE = 'learnerMtSatSurveyMessage';

export const learningAssistancePopupMessageTypeNameSet = new Set([
  CREATE_GOAL_MESSAGE_TYPE,
  GOAL_PROGRESS_MESSAGE_TYPE,
  WEEK_COMPLETION_MESSAGE,
  COURSE_COMPLETED_MESSAGE_TYPE,
  ITEM_COMPLETION_AHEAD_OF_SCHEDULE_MESSAGE_TYPE,
]);
